export function serialize(float32Array) {
  //Make into a normal Array of numbers
  return Array.prototype.slice.call(float32Array)
}

// input can be an array or a string, the string is a way to serialize we used until 30.05.2019
// See here: https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
// if (float32Array.constructor !== Float32Array) throw new Error("I cant serialize that! Constructor is "+float32Array.constructor)
// return String.fromCharCode.apply(null, new Uint16Array(float32Array.buffer))
export function deserialize(input) {
  if (typeof input === 'string') {
    const buf = new ArrayBuffer(input.length * 2) // 2 bytes for each char
    const bufView = new Uint16Array(buf)
    for (let i = 0, strLen = input.length; i < strLen; i++) {
      bufView[i] = input.charCodeAt(i)
    }
    return new Float32Array(buf)
  } else {
    return new Float32Array(input)
  }
}

export function serializeObject(objectOfFloatArrays) {
  const serializedObject = {}
  Object.keys(objectOfFloatArrays).forEach((k) => {
    serializedObject[k] = serialize(objectOfFloatArrays[k])
  })
  return serializedObject
}

export function deserializeObject(objectOfSerializedStrings) {
  const deserializedObject = {}
  Object.keys(objectOfSerializedStrings).forEach((k) => {
    deserializedObject[k] = deserialize(objectOfSerializedStrings[k])
    if (deserializedObject[k].filter((i) => isNaN(i)).length) {
      let brokenI = deserializedObject[k].findIndex((a) => isNaN(a))
      throw new Error(
        `deserializeObject - Failed to read buffer: a value is NaN at ${brokenI} for ' + ${k}`
      )
    }
  })

  return deserializedObject
}
